// extracted by mini-css-extract-plugin
export default {"wrapper":"children-settings_wrapper__rMCyJ","empty":"children-settings_empty__AgnRi"};